import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页-重庆华辉涂料有限公司'
          }
        }, {
          path: '/about_us',
          name: 'about_us',
          component: resolve => require(['@/view/about_us'], resolve),
          meta: {
            title: '关于华辉'
          }
        }, {
          path: '/about_honor',
          name: 'about_honor',
          component: resolve => require(['@/view/about_us/honor'], resolve),
          meta: {
            title: '关于华辉'
          }
        }, {
          path: '/news_center',
          name: 'news_center',
          component: resolve => require(['@/view/news_center'], resolve),
          meta: {
            title: '新闻中心'
          }
        },{
          path: '/news_detail',
          name: 'news_detail',
          component: resolve => require(['@/view/news_detail'], resolve),
          meta: {
            title: '新闻详情'
          }
        }, {
          path: '/contact_us',
          name: 'contact_us',
          component: resolve => require(['@/view/contact_us'], resolve),
          meta: {
            title: '联系我们'
          }
        }, {
          path: '/research',
          name: 'research',
          component: resolve => require(['@/view/research'], resolve),
          meta: {
            title: '研发中心'
          }
        }, {
          path: '/cases',
          name: 'cases',
          component: resolve => require(['@/view/cases'], resolve),
          meta: {
            title: '成功案例'
          }
        }, {
          path: '/cases_detail',
          name: 'cases_detail',
          component: resolve => require(['@/view/cases_detail'], resolve),
          meta: {
            title: '案例详情'
          }
        },{
          path: '/automotive_bumper',
          name: 'automotive_bumper',
          component: resolve => require(['@/view/automotive_bumper'], resolve),
          meta: {
            title: '汽车保险杠涂料'
          }
        },{
          path: '/automotive_hub',
          name: 'automotive_hub',
          component: resolve => require(['@/view/automotive_hub'], resolve),
          meta: {
            title: '汽车轮毂涂料'
          }
        },{
          path: '/automotive_water',
          name: 'automotive_water',
          component: resolve => require(['@/view/automotive_water'], resolve),
          meta: {
            title: '水性汽车原厂涂料'
          }
        },{
          path: '/automotive_solvent',
          name: 'automotive_solvent',
          component: resolve => require(['@/view/automotive_solvent'], resolve),
          meta: {
            title: '溶剂型汽车原厂涂料'
          }
        },{
          path: '/industrial_heavy',
          name: 'industrial_heavy',
          component: resolve => require(['@/view/industrial_heavy'], resolve),
          meta: {
            title: '重防腐涂料'
          }
        },{
          path: '/industrial_motorcycle',
          name: 'industrial_motorcycle',
          component: resolve => require(['@/view/industrial_motorcycle'], resolve),
          meta: {
            title: '摩托车涂料'
          }
        },{
          path: '/industrial_tricycle',
          name: 'industrial_tricycle',
          component: resolve => require(['@/view/industrial_tricycle'], resolve),
          meta: {
            title: '三轮车涂料'
          }
        },{
          path: '/industrial_vehicle',
          name: 'industrial_vehicle',
          component: resolve => require(['@/view/industrial_vehicle'], resolve),
          meta: {
            title: '低速机动车涂料'
          }
        },{
          path: '/coating_service',
          name: 'coating_service',
          component: resolve => require(['@/view/coating_service'], resolve),
          meta: {
            title: '涂装一体化服务'
          }
        },{
          path: '/coating_service',
          name: 'coating_service',
          component: resolve => require(['@/view/coating_service'], resolve),
          meta: {
            title: '涂装服务'
          }
        },{
          path: '/coating_service',
          name: 'coating_service',
          component: resolve => require(['@/view/coating_service'], resolve),
          meta: {
            title: '涂装服务'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js